import React, { useState } from "react";
import Fade from "react-reveal/Fade";
// import "../../Pages/Home/node_modules/bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import "./landingpage.css";
import Logo from "../assets/logo.png";
// import Logo from '../assets/smartLogo.svg';
import Phone from "../assets/phone.svg";
import HomeCalculation from "../HomeCalculation";
import Banner from "../assets/banner.png";
// import MoneyEmoji from "../assets/smiley.png";
import { useSnackbar } from "notistack";
import BTCRate from "../BTCRate";

const Landingpage = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      enqueueSnackbar("Email fields is required", {
        variant: "error",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
    } else props.history.push(`/register/email=${email}`);
  };

  return (
    <div className="bts-landing-page-wrapper">
      <Navbar className="navbg d-md-none" expand="lg" fixed="top">
        <Navbar.Brand href="/">
          <img src={Logo} alt="" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            {!props.user && (
              // <Link to="/exchange" className="notactive whiteText">
              // </Link>
              <Nav.Link href="/exchange" className="nav-items">
                Rates
              </Nav.Link>
            )}
            {!props.user && (
              <Nav.Link href="/login" className="nav-items">
                Login
              </Nav.Link>
            )}
            {props.user && (
              <Nav.Link href="/dashboard" className="nav-items">
                Dashboard
              </Nav.Link>
            )}
            {!props.user && (
              <Nav.Link href="/register" className="nav-items">
                Register
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <div className="bts-landing-page-caption-section">
        <div className="container">
          <div className="bts-landing-left-menu">
            <div className="bts-landing-page-caption-logo">
              <Link to="/">
                <img src={Logo} alt="" />
              </Link>
            </div>
            <div className="bts-landing-page-caption-links align-self-center d-flex justify-content-end">
              {!props.user && (
                <Link to="/exchange" className="notactive">
                  Rates
                </Link>
              )}
              {!props.user && (
                <Nav.Link href="/login" className="nav-items">
                  Login
                </Nav.Link>
              )}
              {props.user && (
                <Nav.Link href="/dashboard" className="nav-items">
                  Dashboard
                </Nav.Link>
              )}
              {!props.user && (
                <Nav.Link href="/register" className="nav-items">
                  Register
                </Nav.Link>
              )}
            </div>
          </div>
        </div>
        <Fade bottom delay={1000}>
          <div className="text-center push-top whiteText b7 mediumText">
            We buy and sell <br />
            Cryptocurrencies
            <br />
            {/* <img src={MoneyEmoji} alt="" /> */}
          </div>
        </Fade>
        <Fade bottom delay={1200}>
          <p className="whiteText text-center pt-2 b3 medText">
            Trade with us now!
          </p>
        </Fade>
        <Fade bottom delay={1500}>
          <div className="pt text-center">
            <form action="post">
              <div>
                <input
                  type="email"
                  placeholder="Your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  id="emailInput"
                  className="form-input"
                />
              </div>
              <div>
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="submitButton mt-2"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </Fade>
        {!props.user && (
          <Fade delay={1600}>
            <div className="text-center">
              <div className=" b5 medText push">
                <Link to="/exchange" className="whiteText guest">
                  I'm a Guest
                </Link>
              </div>
              <div className="mt-2">
                <Link to="/login" className="bts-caption">
                  Login
                </Link>
              </div>
            </div>
          </Fade>
        )}
      </div>
      <div className="bts-landing-page-testimonials container">
        <div className="d-sm-none d-md-flex d-none justify-content-between nav-align">
          <div className="ts-landing-page-right-menu align-self-center">
            <BTCRate />
          </div>
          <div className="ts-landing-page-right-menu align-self-center">
            <Link to="tel:+2348162898892" className="blueText b7 medText plain">
              <img src={Phone} alt="" className="pr-3" /> Contact Us
            </Link>
          </div>
        </div>
        <div className="d-sm-block d-md-none">
        <div className="mb-3">
            <BTCRate />
          </div>
          <div className="d-flex justify-content-end">
            <Link to="tel:+2348162898892" className="blueText b7 medText plain">
              <img src={Phone} alt="" className="pr-3" /> Contact Us
            </Link>
          </div>
        </div>
        <div className="push-top">
          <Fade bottom delay={1200}>
            <div className="row">
              <div className="col-md-1" />
              <div className="col-md-10">
                <HomeCalculation />
              </div>
              <div className="col-md-1" />
            </div>
          </Fade>
          <div className="push-down2">
            <img src={Banner} alt="" />
            <p className="pt-2">Supported payment methods</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landingpage;
